export const rootName = "";

export const routes = {
  Agent: "https://agent.rocketadvance.ca",
  Broker: "https://broker.rocketadvance.ca",
  Referral: "https://referral.rocketadvance.ca",
  Referral: "https://referral.rocketadvance.ca",
  Investor: "https://investor.rocketadvance.ca",
};
